import { getCookie } from 'helper/cookie';
import React, { createContext, FunctionComponent, ReactNode, useContext, useEffect, useState } from 'react';

type BranchContextType = {
  branch: { code: string; name: string };
  handleChangeBranch: (storeId: string, branchCode?: string) => void;
};

export const branches: Array<{ code: string; name: string }> = [
  { code: '01', name: 'RJ' },
  { code: '02', name: 'PE' },
  { code: '03', name: 'SC' },
];

const BranchContext = createContext<BranchContextType | undefined>(undefined);

const BranchProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [branch, setBranch] = useState<{ code: string; name: string }>({ code: '', name: '' });

  const handleChangeBranch = (storeId: string, branchCode?: string) => {
    if (branchCode) {
      const branchName = branches.find((item) => item.code === branchCode)?.name;
      const value = { code: branchCode, name: branchName ?? '' };
      setBranch(value);
      localStorage.setItem(`manual_branch:${storeId}`, JSON.stringify(value));
      return;
    }

    const storagedManualBranch = localStorage.getItem(`manual_branch:${storeId}`);

    const branch = storagedManualBranch
      ? (JSON.parse(storagedManualBranch) as { code: string; name: string })
      : undefined;

    if (branch) {
      setBranch(branch);
    }
  };

  useEffect(() => {
    const storeId = getCookie('client_cod');

    if (!storeId) {
      return;
    }

    const storagedManualBranch = localStorage.getItem(`manual_branch:${storeId}`);

    const branch = storagedManualBranch
      ? (JSON.parse(storagedManualBranch) as { code: string; name: string })
      : undefined;

    if (branch) {
      setBranch(branch);
    }
  }, []);

  const value = {
    branch,
    handleChangeBranch,
  };

  return <BranchContext.Provider value={value}>{children}</BranchContext.Provider>;
};

type BranchConsumerProps = {
  children: (context: BranchContextType) => ReactNode;
};

const BranchConsumer: FunctionComponent<BranchConsumerProps> = ({ children }) => {
  return (
    <BranchContext.Consumer>
      {(context) => {
        if (context === undefined) {
          throw new Error('BranchConsumer must be used within BranchProvider');
        }
        return children(context);
      }}
    </BranchContext.Consumer>
  );
};

const useBranch = () => {
  const context = useContext(BranchContext);
  if (context === undefined) {
    throw new Error('useBranch must be used within BranchProvider');
  }
  return context;
};

export { BranchConsumer, BranchProvider, useBranch };
